import {TableDefinition} from '../../models';

export const WORKPLACE_TABLE_DEFINITION: TableDefinition = [
  {
    key: 'API.fields.Workplace.id',
    prop: 'id',
    visible: false,
    objectName: 'Workplace',
    searchFieldType: 'NUMBER',
  },
  {
    key: 'API.fields.Workplace.name',
    prop: 'name',
    visible: true,
    objectName: 'Workplace',
    searchFieldType: 'STRING',
  },
  {
    key: 'API.fields.Workplace.ward',
    prop: 'ward',
    visible: true,
    objectName: 'Workplace',
    searchFieldType: 'STRING',
  },
  {
    key: 'API.fields.Workplace.street',
    prop: 'street',
    visible: true,
    objectName: 'Workplace',
    searchFieldType: 'STRING',
  },
  {
    key: 'API.fields.Workplace.postalCode',
    prop: 'postalCode',
    visible: true,
    objectName: 'Workplace',
    searchFieldType: 'STRING',
  },
  {
    key: 'API.fields.Workplace.city',
    prop: 'city',
    visible: true,
    objectName: 'Workplace',
    searchFieldType: 'STRING',
  },
];
